import { render } from "./CartSchemaJson.vue?vue&type=template&id=218b5245"
import script from "./CartSchemaJson.vue?vue&type=script&lang=js"
export * from "./CartSchemaJson.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__